// ENTITIES
import {
	IFormPesquisaRg,
	RequestPesquisarRg,
} from 'pages/iirgd/RgFicDigital/PesquisaRg/Formulario/form';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	ConsultaPesquisaCidadao,
	IConsultaPesquisaCidadaoSelecionado,
	Types,
} from './types';

export function consultaPesquisaCidadaoRequest(
	token: string,
	data: RequestPesquisarRg,
	form: IFormPesquisaRg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_REQUEST,
		token,
		payload: {
			data,
			form,
		},
	};
}
export function consultaPesquisaCidadaoSuccess(payload: {
	pessoa: ConsultaPesquisaCidadao[];
	contadorCirg: number;
	contadorCino: number;
	contadorCinn: number;
}): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_SUCCESS,
		payload,
	};
}
export function consultaPesquisaCidadaoFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_FAILURE,
		payload: null,
	};
}

export function consultaPesquisaCidadaoSelecionado(
	payload: IConsultaPesquisaCidadaoSelecionado,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_SELECIONADO,
		payload,
	};
}
export function consultaPesquisaCidadaoSelecionadoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_SELECIONADO_CLEAR,
		payload: null,
	};
}

export function consultaPesquisaCidadaoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_CLEAR,
		payload: null,
	};
}

export function consultaPesquisaCidadaoFormPesquisaMae(
	form: IFormPesquisaRg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_FORM_PESQUISA_MAE_REQUEST,
		payload: {
			form,
		},
	};
}
